import "@mantine/core/styles.css";
import "./global.css";

import { MantineProvider } from "@mantine/core";

import "@mantine/charts/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";

import "@mantine/dates/styles.css";
import { Notifications } from "@mantine/notifications";
import { ViewAsBanner } from "./components/ViewAs/ViewAsBanner";
import { Router } from "./router/Router";
import { theme } from "./theme";

export default function App() {
  return (
    <MantineProvider theme={theme}>
      <Notifications />
      <ViewAsBanner />
      <Router />
    </MantineProvider>
  );
}
